<template>
    <nav class="navbar navbar-expand-md navbar-light bg-light fixed-top past-main effect-main">
        <div class="container container-s">
            <router-link class="navbar-brand" to="/">
                Mauricio Sebastián Neira_
            </router-link>
            <button class="navbar-toggler" @click="toggle = !toggle" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent" v-show="!toggle">
                <ul class="navbar-nav ml-auto navbar-right">
                    <router-link tag="li" to="/resume" class="nav-item">
                        <a class="nav-link js-scroll-trigger">Resume_</a>
                    </router-link>
                    <router-link tag="li" to="/portafolio" class="nav-item">
                        <a class="nav-link js-scroll-trigger">Portafolio_</a>
                    </router-link>
                    <router-link tag="li" to="/testimonials" class="nav-item">
                        <a class="nav-link js-scroll-trigger">Testimonials_</a>
                    </router-link>
                    <router-link tag="li" to="/blog" class="nav-item">
                        <a class="nav-link js-scroll-trigger">Blog_</a>
                    </router-link>
                    <router-link tag="li" to="/contact" class="nav-item">
                        <a class="btn-cta nav-link js-scroll-trigger">Contact_</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'HeaderBar',
    data: function (){
        return  {
            toggle: true
        }
    },
    // methods : {
    //     menu () {
    //         $('navbarSupportedContent').show();
    //     }
    // }
}
</script>
    
<style lang="stylus">
.navbar-toggler
    padding: .25rem .75rem
    font-size: 1.25rem
    line-height: 1
    background-color: transparent
    border: 1px solid transparent
    border-radius: .25rem
.ml-auto, .mx-auto
    margin-left: auto!important
.navbar-nav
    text-align: center
    margin-top: 15px
    background: #FFF
    -webkit-transition: 0.5s all ease
    transition: 0.5s all ease
    display: flex
    padding-left: 0
    margin-bottom: 0
    list-style: none
.navbar
    font-family: "Montserrat"
    padding-top: 25px
    padding-bottom: 25px
    background-color: transparent !important
    -webkit-transition: 0.5s all ease
    transition: 0.5s all ease
    display: inline-block
    padding-top: .3125rem
    padding-bottom: .3125rem
    line-height: inherit
    white-space: nowrap
    padding: .5rem 1rem
    .navbar-brand
        font-family: 'Montserrat'
        font-size: 16px
        font-weight: 600
        letter-spacing: 0
        color: #6d48e5 !important
        vertical-align: middle
        display: inline-block
        padding-top: .3125rem
        padding-bottom: .3125rem
        margin-right: 1rem
        line-height: inherit
        white-space: nowrap
    .navbar-toggler
        border: none
	span 
		&.navbar-toggler-icon 
			&::before 
				outline none
	.navbar-toggler 
		&:focus 
			outline none
.navbar>.container, .navbar>.container-fluid
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    -ms-flex-wrap: wrap
    flex-wrap: wrap
    -webkit-box-align: center
    -ms-flex-align: center
    align-items: center
    -webkit-box-pack: justify
    -ms-flex-pack: justify
    justify-content: space-between
.navbar-toggler:not(:disabled):not(.disabled)
    cursor: pointer
.navbar-nav 
    .nav-item
        margin-right: 0
        margin-top: 1.5rem
        font-size: 0.85rem
        font-weight: 400
        text-transform: capitalize
        color: #563D7C
        .nav-link
            color: #364655
            font-weight: 500
            display: block
            padding: .5rem 1rem
.navbar-toggler-icon
    display: inline-block
    width: 1.5em
    height: 1.5em
    vertical-align: middle
    content: ""
    background: no-repeat center center
    background-size: 100% 100%
.navbar-collapse
    flex-basis: 100%
    -webkit-box-flex: 1
    flex-grow: 1
    -webkit-box-align: center
    align-items: center
.collapse.show
    display: block
.fixed-top
    position: fixed
    top: 0
    right: 0
    left: 0
    z-index: 1030

@media only screen and (max-width: 768px)
    .navbar .navbar-nav
        padding-bottom: 25px
        display: block

@media (min-width: 768px)
    .navbar-expand-md
        -webkit-box-orient: horizontal
        -webkit-box-direction: normal
        -ms-flex-flow: row nowrap
        flex-flow: row nowrap
        -webkit-box-pack: start
        -ms-flex-pack: start
        justify-content: flex-start
    .navbar-expand-md>.container, .navbar-expand-md>.container-fluid
        -ms-flex-wrap: nowrap
        flex-wrap: nowrap
    .navbar-expand-md .navbar-toggler
        display: none
    .navbar-expand-md .navbar-collapse
        display: -webkit-box!important
        display: -ms-flexbox!important
        display: flex!important
        -ms-flex-preferred-size: auto
        flex-basis: auto
    .navbar-expand-md .navbar-nav
        -webkit-box-orient: horizontal
        -webkit-box-direction: normal
        -ms-flex-direction: row
        flex-direction: row
    .navbar-expand-md .navbar-nav .nav-link
        padding-right: .5rem
        padding-left: .5rem

@media (max-width: 767.98px)
    .navbar-expand-md>.container, .navbar-expand-md>.container-fluid
        padding-right: 0
        padding-left: 0

@media only screen and (min-width: 240px)
    .navbar
    .past-main
        font-family: "Montserrat";
        padding-top: 15px
        padding-bottom: 15px
        background-color: rgba(255, 255, 255, 0.99) !important
        -webkit-box-shadow: 0 2px 3px 0 rgba(96, 96, 96, 0.1)
        -moz-box-shadow: 0 2px 3px 0 rgba(96, 96, 96, 0.1)
        box-shadow: 0 2px 3px 0 rgba(96, 96, 96, 0.1)
        .navbar-brand
            color: #6d48e5 !important
    .container-s
        padding-left: 40px
        padding-right: 40px
        .navbar-nav
            margin-top: 0
        .nav-item 
            margin-top: 0
            margin-right: 15px
            font-size: 0.85rem
            font-weight: 400
    .navbar.past-main span.navbar-toggler-icon
       background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0,0,0, 0.9)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E")
    .btn-cta
        font-family: 'Montserrat'
        display: inline-block
        height: 30px
        padding: 0 30px !important
        text-align: center
        font-size: 12px
        font-weight: 700
        line-height: 28px
        letter-spacing: 1px
        text-transform: capitalize
        text-decoration: none !important
        white-space: nowrap
        cursor: pointer
        background-color: #387ed1
        background: #6d48e5
        color: #FFFFFF !important
        border: 1px solid transparent !important
        border-radius: 4px
        box-sizing: border-box
        -webkit-transition: 0.2s
        -moz-transition: 0.2s
        transition: 0.2s

</style>
